import { ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { Link } from 'react-router-dom';
import { MagneticButton } from '@/components/MagneticButton';

export const CTASection = ({
  kicker = "Ready to book your session?",
  title = "LET'S CREATE SOMETHING AMAZING.",
  testId = 'cta-banner',
  buttonTestId = 'cta-book-now-button',
}) => {
  return (
    <section className="border-t border-[hsl(var(--lxra-gold))]/30 bg-[#0A0A0A]" data-testid={testId}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-14 flex flex-col sm:flex-row items-center sm:items-center justify-between gap-6">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-[hsl(var(--lxra-gold))]">{kicker}</p>
          <h2 className="font-display text-3xl sm:text-4xl mt-2 tracking-[0.03em] text-[hsl(var(--lxra-fg))]">{title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="flex flex-col sm:flex-row items-center gap-3">
          <MagneticButton>
            <Link to="/book" data-testid={buttonTestId}>
              <button className="inline-flex items-center h-12 px-7 rounded-xl bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] transition-colors duration-200 text-sm uppercase tracking-[0.1em] font-semibold whitespace-nowrap">
                Book Now
                <ArrowRight className="ml-2 h-4 w-4" />
              </button>
            </Link>
          </MagneticButton>
        </Reveal>
      </div>
    </section>
  );
};
